import { ErrorBoundary } from '@ets/design-system';

import { CSSProperties, ReactNode } from 'react';

export type ContentFallbackProps = {
  scale?: CSSProperties['scale'];
  margin?: CSSProperties['margin'];
  backgroundColor?: CSSProperties['backgroundColor'];
  width: CSSProperties['width'];
  height: CSSProperties['height'];
  children: ReactNode;
};

const ContentFallback = ({ ...props }: ContentFallbackProps) => {
  const { scale, width, height, margin, backgroundColor, children } = props;
  return (
    <ErrorBoundary
      style={{
        margin: margin,
        display: 'flex',
        scale: `${scale ?? 1}`,
        width,
        height,
        backgroundColor: backgroundColor ?? 'white',
      }}
      size="l"
    >
      {children}
    </ErrorBoundary>
  );
};

export default ContentFallback;
